export const typedQuery = <T = HTMLElement>(s: string): T => {
  return document.querySelector(s) as unknown as T;
};

export function scaleFloat(input: number, inMin: number, inMax: number, outMin: number, outMax: number) {
  var percent = (input - inMin) / (inMax - inMin);
  var output = percent * (outMax - outMin) + outMin;
  return output;
}